import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useFetch } from "@/hooks/useFetch";
import { useMe } from "@/components/app/MeContext";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

// Engineering Studio machine token: generate / rotate (shown once) and recent calls
export function ServiceTokenPanel() {
  const { can } = useMe();
  return can("admin.settings") ? <TokenPanel /> : null;
}

function TokenPanel() {
  const [k, setK] = useState(0);
  const [token, setToken] = useState("");
  const { data } = useFetch(`/admin/service-token?k=${k}`);
  const rotate = async () => {
    if (data?.configured && !window.confirm("Rotate the token? Every older token (including one set in the server settings) stops working within a few seconds - update CONNECT_API_TOKEN in Engineering Studio.")) return;
    try { const r = await api.post("/admin/service-token/rotate"); setToken(r.data.token); setK((x) => x + 1); } catch (e) { toast.error(errMsg(e)); }
  };
  const copy = () => navigator.clipboard?.writeText(token).then(() => toast.success("Token copied"));
  return (
    <div className="mt-8 rounded-md border border-slate-200 bg-white p-4" data-testid="service-token-panel">
      <h3 className="text-sm font-semibold">Engineering Studio service token (CONNECT_API_TOKEN)</h3>
      <p className="mt-1 text-xs text-slate-500">Lets Engineering Studio read items, create DRAFT items and set engineering fields - nothing else. {data?.configured ? `Active token ends …${data.hint || "(from env)"}${data.created_at ? `, created ${fmtDateTime(data.created_at)} by ${data.created_by?.name}` : ""}.` : "No token yet."}</p>
      <Button size="sm" className="mt-2" onClick={rotate} data-testid="service-token-rotate">{data?.configured ? "Rotate token" : "Generate token"}</Button>
      {token && <div className="mt-3 rounded border border-amber-300 bg-amber-50 p-2 text-xs" data-testid="service-token-value">
        <b>Copy it now - it is shown only once:</b>
        <div className="mt-1 flex items-center gap-2"><code className="break-all font-mono">{token}</code><Button size="sm" variant="outline" className="h-7" onClick={copy}>Copy</Button></div></div>}
      <div className="mt-3 max-h-56 overflow-y-auto text-xs" data-testid="service-token-calls">
        <div className="font-semibold text-slate-600 mb-1">Recent calls</div>
        {(data?.calls || []).map((c) => <div key={`${c.at}-${c.path}`} className="flex gap-2 border-b border-slate-100 py-1 font-mono"><span>{fmtDateTime(c.at)}</span><span>{c.method}</span><span className="truncate">{c.path}{c.query ? `?${c.query}` : ""}</span><span className="ml-auto">{c.status}</span></div>)}
        {!data?.calls?.length && <div className="text-slate-400">No calls yet</div>}
      </div>
    </div>
  );
}
